import Text from '../../Text'

interface Props {
  primary: string
  secondary?: string
  onClick?: () => void
}

const TextCell = ({ primary, secondary, onClick }: Props) => (
  <>
    {onClick ? (
      <Text variant={typeof onClick === 'function' ? 'link' : undefined} ellipsis onClick={onClick} cursor="pointer">
        {primary}
      </Text>
    ) : (
      <Text ellipsis>{primary}</Text>
    )}
    {secondary && (
      <Text ellipsis color="gray5" fontSize={13} mt="0.2rem">
        {secondary}
      </Text>
    )}
  </>
)

export default TextCell
